import { SelectBox } from '@components/selectbox';
import { cn } from '@utils/helpers';
import { InfoIcon } from 'lucide-react';
import { useCallback, useState } from 'react';
import { useFragment } from 'react-relay';
import { CategoryInfo } from '../categoryInfo';
import { sortYearsDescending } from '../sortYears';
import { detailFilterDropdownCategoryFragment } from './DetailFilterDropdownCategory.relay';
import type { DetailFilterDropdownCategoryPropsType } from './types';

const DetailFilterDropdownCategory: React.FC<DetailFilterDropdownCategoryPropsType> = (props) => {
  const category = useFragment(detailFilterDropdownCategoryFragment, props.category);

  const [infoVisible, setInfoVisible] = useState(false);

  const aggregateFilterVals = useCallback(
    (key: string, option: { key: string; label: string; data: string }) => {
      props.filterHandlerFn(category.col, option.data ? option.data : [], option.key ? option.key : null);
    },
    [props.filterHandlerFn, category.col],
  );

  const toggleInfo = useCallback((): void => {
    setInfoVisible((prev) => !prev);
  }, []);

  const closeInfo = useCallback((): void => {
    setInfoVisible(false);
  }, []);

  const showCategoryName = category.categoryname || category.info;

  return (
    <div className="flex flex-wrap items-start justify-start pb-[5px] max-[1100px]:pb-2.5">
      {showCategoryName ? (
        <div className="flex w-[23%] max-[1100px]:order-1 max-[1100px]:w-full items-center gap-2">
          <span>{category.categoryname}</span>
          {category.info ? <InfoIcon onClick={toggleInfo} className={cn('text-gray-300 size-5', infoVisible && 'fill-accent text-white')} /> : null}
        </div>
      ) : null}

      <div className="w-[77%] max-[1100px]:order-3 max-[1100px]:w-full">
        <SelectBox
          selectBox={category.selectbox}
          width="250px"
          selected={props.filterVals?.key || 'all'}
          onChange={aggregateFilterVals}
          className="SelectBox-wide"
          sort={category.col === 'year' ? sortYearsDescending : undefined}
        />
      </div>
      {showCategoryName && category.info ? (
        <div className="mt-[-10px] w-full max-[1100px]:order-2 max-[1100px]:mt-0">
          <CategoryInfo info={category.info} close={closeInfo} visible={infoVisible} />
        </div>
      ) : null}
    </div>
  );
};

export { DetailFilterDropdownCategory };
